import { CommonModule } from '@angular/common';
import { Component, input, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { MediaService } from '@app/services/media.service';

@Component({
    selector: 'clever-bosyshotellist',
    imports: [
        CommonModule,
        MatIconModule
    ],
    templateUrl: './bosyshotellist.html',
    styleUrl: './bosyshotellist.scss'
})
export class Bosyshotellist {
    offers = input<any>(null);
    offerid = input<any>(null);
    currentrecid = input<number>(0);

    showitem = signal<boolean>(false);

    constructor(
        protected mediaService: MediaService,
        protected router: Router
    ) { }

    async gotoOffer(offer) {
        const path = this.router.createUrlTree(['offers', this.offerid(), offer.recid]).toString();
        const link = document.createElement('a');
        link.href = path;
        link.setAttribute('visibility', 'hidden');
        link.click();

    }

    async openItem(ev) {
        ev.stopPropagation();
        this.showitem.set(!this.showitem());
    }

    async gotolist(ev) {
        ev.stopPropagation();
        const path = this.router.createUrlTree(['offers', this.offerid()]).toString();
        const link = document.createElement('a');
        link.href = path;
        link.setAttribute('visibility', 'hidden');
        link.click();
    }

}
